import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CompanyService } from '../../../_services/company.service';

@Component({
  selector: 'app-delete-company',
  templateUrl: './delete-company.component.html',
  styleUrls: ['./delete-company.component.css']
})
export class DeleteCompanyComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;

  constructor(private service: CompanyService) { }

  ngOnInit() {
  }

  openModal(company_id){
    this.to_delete = company_id;
    jQuery('#delete-company-modal').modal({closable: false}).modal('show');
  }

  deleteCompany(){
    if(!this.to_delete) { // Return false if the ID of the contact is not stored
      jQuery('#delete-contact-modal').modal('hide');
      return false;
    } 
    let company_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the contact to delete (avoid spamming during the deletion process)
    jQuery('#delete-company-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    this.service.deleteCompany(company_id) // Delete the Contact
      .subscribe(response => {
        jQuery('#delete-company-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company/delete-company/delete-company.component.ts